// components/viz/ResidualHistogram.jsx
// 残差分布直方图

export default function ResidualHistogram({ diag }) {
  if (!diag) return null;
  const W = 380, H = 220, pad = 40;
  const w = W - 2 * pad, h = H - 2 * pad;
  const residuals = diag.points.map(p => p.pred - p.exp);
  const maxAbs = Math.max(...residuals.map(Math.abs));
  const bins = 20;
  const binSize = (2 * maxAbs) / bins;
  const counts = new Array(bins).fill(0);
  residuals.forEach(r => {
    const idx = Math.min(bins - 1, Math.max(0, Math.floor((r + maxAbs) / binSize)));
    counts[idx]++;
  });
  const maxCount = Math.max(...counts);
  return (
    <svg viewBox={`0 0 ${W} ${H}`} style={{ width: "100%" }}>
      <rect x={pad} y={pad} width={w} height={h} fill="#ffffff" stroke="#cbd5e1" />
      {counts.map((c, i) => {
        const bx = pad + (i / bins) * w;
        const bw = w / bins - 1.5;
        const bh = (c / maxCount) * h;
        const center = -maxAbs + (i + 0.5) * binSize;
        return <rect key={i} x={bx} y={pad + h - bh} width={bw} height={bh} fill={Math.abs(center) < binSize ? "#10b981" : "#0ea5e9"} opacity="0.85" />;
      })}
      {/* zero line */}
      <line x1={pad + w / 2} y1={pad} x2={pad + w / 2} y2={pad + h} stroke="#0f172a" strokeWidth="1" strokeDasharray="3,3" opacity="0.5" />
      <text x={pad + w / 2} y={H - 8} textAnchor="middle" fontSize="11" fontFamily="'IBM Plex Sans',sans-serif" fontWeight="600" fill="#0f172a">残差 (预测 − 实验)</text>
      <text x={pad - 6} y={pad + 8} textAnchor="end" fontSize="9" fontFamily="'JetBrains Mono',monospace" fill="#64748b">{maxCount}</text>
      <text x={pad - 6} y={pad + h} textAnchor="end" fontSize="9" fontFamily="'JetBrains Mono',monospace" fill="#64748b">0</text>
      <text x={pad} y={pad + h + 14} textAnchor="middle" fontSize="9" fontFamily="'JetBrains Mono',monospace" fill="#64748b">{(-maxAbs).toFixed(3)}</text>
      <text x={pad + w} y={pad + h + 14} textAnchor="middle" fontSize="9" fontFamily="'JetBrains Mono',monospace" fill="#64748b">{maxAbs.toFixed(3)}</text>
    </svg>
  );
}
